import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { HelpIndex, Endpoint } from '../../../models/enums';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { Permissions, ObjectActionListType } from '../../../models/permission';

@Component({
    standalone: false,
    selector: 'res-download-word-list-modal',
    templateUrl: './download-word-list-modal.component.html',
    styleUrls: ['./download-word-list-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DownloadWordListModalComponent extends BaseModalComponent implements OnInit {
    modalAutomationId = 'download-word-list';
    modalClass = 'download-word-list-modal';
    modalHelpIndex = HelpIndex.download_word_list_dlg;
    isBusy = false;
    isBusyMessage = 'Loading ...';

    isDownloadToCsv = true;
    fileName: string;
    exportDataAreas = null;
    selectedDataArea: any = null;
    hasConnAccessPermissions: boolean;

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private commonService: CommonService,
        private restService: RestService,
    ) {
        super(modalService, modalRef);
    }

    ngOnInit() {
        this.hasConnAccessPermissions = Permissions.checkUserPermission(ObjectActionListType.CONNECTOR_ACCESS);
        if (this.hasConnAccessPermissions) {
            this.loadDataAreas();
        }
    }

    loadDataAreas(): void {
        this.isBusy = true;
        this.restService.post(Endpoint.orgManager_listExportDataAreas, {}).then(response => {
            this.isBusy = false;
            if (response && response.exportDataAreas) {
                this.exportDataAreas = response.exportDataAreas;
            } else {
                this.exportDataAreas = [];
            }
        }, () => {
            this.isBusy = false;
        });
    }

    isPrimaryButtonEnabled(): boolean {
        return !this.isBusy && (this.isDownloadToCsv || (!this.isDownloadToCsv && this.selectedDataArea !== null && this.fileName.trim() !== ''));
    }

    ok(): void {
        if (this.modalData && this.modalData.sourceViewHandle) {
            this.isBusyMessage = 'Downloading ...';
            this.isBusy = true;
            const request = {
                downloadWordListLimit: 0,
                manifestFormat: 'CSV',
                sortDescending: this.modalData.sortDescending,
                sortField: this.modalData.sortField ? this.modalData.sortField : 'docs',
                sourceViewHandle: this.modalData.sourceViewHandle,
                taskDescription: 'Downloading Word list manifest',
                wordListFilter: this.modalData.wordListFilter
            };
            if (!this.isDownloadToCsv) {
                request.taskDescription = 'Saving Word List manifest';
                const targetInfo = { targetDataAreaHandle: this.selectedDataArea.handle, targetPath: this.fileName };
                Object.assign(request, targetInfo);
            }
            this.restService.post(Endpoint.viewManager_exportWordListManifestFile, request, true, true).then((response) => {
                if (response) {
                    this.commonService.openInformationToastNotification('The word list may take some time to download. You can monitor the download process in the Work Basket panel.');
                }
            });
            this.isBusy = false;
            this.closeModal();
        }
    }
}
